module.exports = __webpack_public_path__ + "/images/list-loader.gif";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/list-loader.gif
// module id = 620
// module chunks = 0